export default "__VITE_ASSET__BsE6H9b___"